import { BMRField, Range, TDEEField } from './types';

const MEN_BMR = 66;
const WOMEN_BMR = 655;

const roundNumber = (num: number): number => {
  return Math.round(num);
};

export const calculateBMR = ({
  gender,
  weight,
  height,
  age,
}: BMRField): number => {
  switch (gender) {
    case 'bro':
      return roundNumber(
        // eslint-disable-next-line prettier/prettier
        MEN_BMR +
          13.7 * Number(weight) +
          5 * Number(height) -
          6.8 * Number(age),
      );

    case 'sis':
      return roundNumber(
        // eslint-disable-next-line prettier/prettier
        WOMEN_BMR +
          9.6 * Number(weight) +
          1.8 * Number(height) -
          4.7 * Number(age),
      );

    default:
      return 0;
  }
};

export const calculateTDEE = ({
  gender,
  weight,
  height,
  age,
  activity,
}: TDEEField): number => {
  return roundNumber(
    calculateBMR({
      gender,
      weight,
      height,
      age,
    }) * Number(activity),
  );
};

export const approxCaloriesPerDay = (tdee: number): Range => ({
  from: roundNumber(0.75 * tdee),
  to: roundNumber(0.85 * tdee),
});

export const approxCaloriesPerMeal = (tdee: number): Range => ({
  from: roundNumber((0.75 * tdee) / 3),
  to: roundNumber((0.85 * tdee) / 3),
});

export const approxWeightLoss = (tdee: number): Range => ({
  from: Math.round(((0.15 * tdee * 14) / 3500) * 0.25 * 100) / 100,
  to: Math.round(((0.25 * tdee * 14) / 3500) * 0.45 * 100) / 100,
});

export const recommendedMealCalories = (bmr: number) =>
  roundNumber(bmr / 3);

export const formatNumberWithCommas = (num: number) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
